export default function Line() {
    return (<svg xmlns="http://www.w3.org/2000/svg" width="1" height="26" viewBox="0 0 1 26" style={{ margin: "7.5px" }}>
        <line id="Line_1093" data-name="Line 1093" y2="25" transform="translate(0.5 0.5)" fill="none" stroke="#cecdcd" strokeLinecap="round" strokeWidth="1" />
    </svg>
    )
}